import React from 'react';
import { Card } from '../ui/Card';
import { AdminAstrologer } from '../../data/adminMockData';
interface AdminProfilesManagerProps {
  astrologers: AdminAstrologer[];
  renderStatusBadge: (status: string) => React.ReactNode;
  renderTableHeader: (title: string, count: number, onExport?: () => void) => React.ReactNode;
  generateCSV: (data: any[], name: string) => void;
}
export function AdminProfilesManager({
  astrologers,
  renderStatusBadge,
  renderTableHeader,
  generateCSV
}: AdminProfilesManagerProps) {
  return <div className="space-y-4" data-id="element-6917">
      {renderTableHeader('Профили астрологов', astrologers.length, () => generateCSV(astrologers, 'profiles'))}
      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-6918">
        <table className="w-full text-left" data-id="element-6919">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-6920">
            <tr data-id="element-6921">
              <th className="px-3 py-2" data-id="element-6922">Астролог</th>
              <th className="px-3 py-2" data-id="element-6923">Специализация</th>
              <th className="px-3 py-2" data-id="element-6924">Рейтинг</th>
              <th className="px-3 py-2" data-id="element-6925">Статус</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-6926">
            {astrologers.map(a => <tr key={a.id} className="hover:bg-slate-50" data-id="element-6927">
                <td className="px-3 py-2 text-sm font-medium" data-id="element-6928">{a.name}</td>
                <td className="px-3 py-2 text-xs text-slate-500" data-id="element-6929">{a.spec}</td>
                <td className="px-3 py-2 text-sm" data-id="element-6930">⭐ {a.rating}</td>
                <td className="px-3 py-2" data-id="element-6931">{renderStatusBadge(a.status)}</td>
              </tr>)}
          </tbody>
        </table>
      </Card>
    </div>;
}